import { render } from "./LearningHub.vue?vue&type=template&id=22142d0a&scoped=true"
import script from "./LearningHub.vue?vue&type=script&lang=js"
export * from "./LearningHub.vue?vue&type=script&lang=js"

import "./LearningHub.vue?vue&type=style&index=0&id=22142d0a&lang=css"
import "./LearningHub.vue?vue&type=style&index=1&id=22142d0a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22142d0a"]])

export default __exports__